import React from 'react';
import { Modal, Button, notification } from 'tea-component';
import './index.scss';
import { useIntl } from 'umi';

const UnfollowModal = (porps: any) => {
  let { visible, click, setUnfollow } = porps;
  const { formatMessage } = useIntl(); // 中英切换方法

  return (
    <Modal
      className="dbi-unfollow-group"
      visible={visible}
      size={500}
      onClose={() => setUnfollow && setUnfollow()}
    >
      <Modal.Body>
        <div className="dbi-unfollow-group-title">
          Do you want to unfollow all selected games?
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="primary"
          onClick={() => {
            click && click();
            setUnfollow && setUnfollow();
            // notification.success({
            //   description: 'Success Unfollow',
            //   duration: 3000,
            // });
          }}
        >
          {formatMessage({ id: 'dbi_confirm' })}
        </Button>
        <Button
          type="weak"
          onClick={() => {
            setUnfollow && setUnfollow();
            // notification.error({
            //   duration: 3000,
            //   description: 'Failed Unfollow, please try again.',
            // });
          }}
        >
          {formatMessage({ id: 'dbi_cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UnfollowModal;
